var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activity-viewer',{attrs:{"page":1,"count":10,"buildingId":_vm.$route.params.buildingId}})}
var staticRenderFns = []

export { render, staticRenderFns }